import { defineStore } from 'pinia';
import { usePriceListStore } from './price-list';
import { useGlobalStore } from './global';
import { renderDialogContent } from '../utils';
export const useCombinationTipsStore = defineStore('combination-tips-store', {
    getters: {
        currentCombination() {
            const priceListStore = usePriceListStore();
            const globalStore = useGlobalStore();
            // 需要判断是不是配置总览，先不处理，看下效果
            //   if (globalStore?.showAllPage) {
            //     const showAllListStore = useShowAllListStore()
            //     return showAllListStore.selectOptionalPackTip() || null
            //   }
            // return {
            //   icon: 'https://cdn-fx.nio.com/fx/vom-config-front/__cdn__/otd_car_config_discount_icon.png',
            //   tip: '仅差{2}项选装，立减{¥7,000}',
            // }
            console.log('---selectOptionalPackTip---', priceListStore?.selectOptionalPackTip);
            return priceListStore?.selectOptionalPackTip || null;
        },
        calculateContent() {
            if (!this.currentCombination)
                return '';
            return renderDialogContent(this.currentCombination?.tip ?? '');
        },
    },
});
